var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95745 12.625L15.0199 5.5625C15.1866 5.39583 15.3845 5.3125 15.6137 5.3125C15.8429 5.3125 16.0408 5.39583 16.2074 5.5625C16.3741 5.72917 16.4574 5.92708 16.4574 6.15625C16.4574 6.38542 16.3741 6.58333 16.2074 6.75L8.54078 14.4167C8.37411 14.5833 8.17967 14.6667 7.95745 14.6667C7.73523 14.6667 7.54078 14.5833 7.37411 14.4167L3.79078 10.8333C3.62411 10.6667 3.54425 10.4688 3.5512 10.2396C3.55814 10.0104 3.64495 9.8125 3.81161 9.64583C3.97828 9.47917 4.1762 9.39583 4.40536 9.39583C4.63453 9.39583 4.83245 9.47917 4.99911 9.64583L7.95745 12.625Z",
    fill: "#084F4B",
    stroke: "#084F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickEditIcon);
export default __webpack_public_path__ + "static/media/tick-edit-icon.04af2c0125607b95d0f0da550d616e1c.svg";
export { ForwardRef as ReactComponent };